import { render, staticRenderFns } from "./upAndDown.vue?vue&type=template&id=3221c7e7&scoped=true"
import script from "./upAndDown.vue?vue&type=script&lang=js"
export * from "./upAndDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3221c7e7",
  null
  
)

export default component.exports